import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import apiFetch from './api';
import './css/Results.css';

export default function Results() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const commitId = params.get('commitId');
    const json = params.get('json');
    const request = params.get('request');
    const jobId = params.get('jobId');
    const jobStatus = params.get('status');
    const jobMessage = params.get('message');

    const removeNulls = (obj) => {
        if (typeof obj !== 'object' || obj === null) return obj;
        return Object.fromEntries(
            Object.entries(obj)
                .filter(([, v]) => v !== null && v !== undefined)
                .map(([k, v]) => [k, removeNulls(v)])
        );
    };

    const formatPayload = (raw) => {
        try {
            const parsed = JSON.parse(decodeURIComponent(raw));
            return JSON.stringify(removeNulls(parsed), null, 2);
        } catch (e) {
            return raw;
        }
    };

    const handleBackToForm = () => {
        navigate('/api/eventgenerator');
    };

    const handleLogout = async () => {
        try {
            await apiFetch('/api/auth/logout', { method: 'POST' });
        } catch (e) {
            console.warn('Logout request failed', e);
        } finally {
            window.location.assign('/login?logout');
        }
    };

    return (
        <div className="results-container">
            <button className="logout-button" onClick={handleLogout}>
                Logout
            </button>

            <div className="results-content">
                <h2>Submission Results</h2>

                {jobId && (
                    <div className="result-section">
                        <div className="result-item">
                            <strong>Job ID:</strong>
                            <span className="result-value">{jobId}</span>
                        </div>
                        {jobStatus && (
                            <div className="result-item">
                                <strong>Status:</strong>
                                <span className={`result-value status-${jobStatus}`}>{jobStatus}</span>
                            </div>
                        )}
                        {jobMessage && (
                            <div className="result-item">
                                <strong>Message:</strong>
                                <span className="result-value">{jobMessage}</span>
                            </div>
                        )}
                        {request && (
                            <div className="result-section">
                                <div className="result-item">
                                    <strong>Payload:</strong>
                                </div>
                                <pre className="json-output">{formatPayload(request)}</pre>
                            </div>
                        )}
                    </div>
                )}

                {commitId && (
                    <div className="result-section">
                        <div className="result-item">
                            <strong>Commit ID:</strong>
                            <span className="result-value">{commitId}</span>
                        </div>
                    </div>
                )}

                {!commitId && !json && !jobId && !request && (
                    <div className="no-results">
                        <p>No results to display.</p>
                    </div>
                )}

                <button className="back-button" onClick={handleBackToForm}>
                    Back to Event Generator
                </button>
            </div>
        </div>
    );
}
